module.exports = __webpack_public_path__ + "static/07-d1f43252a9d5a7d5831255a5ef5130eb.jpg";